import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
`;

export const Content = styled.div`
  max-width: 900px;
  margin: ${({ theme }) => theme.spacing(6)} auto;
  padding: ${({ theme }) => theme.spacing(8)} ${({ theme }) => theme.spacing(4)};
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(49, 110, 177, 0.95) 0%,
    rgba(78, 158, 163, 0.95) 100%
  );
  color: ${({ theme }) => theme.colors.white};
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  line-height: 1.8;
  font-size: 1.2rem;
  animation: fadeInUp 0.8s ease-out both;

  p {
    margin-bottom: 1.5rem;
  }

  @media (max-width: ${({ theme }) => theme.phoneWidth}) {
    font-size: 1rem;
    padding: ${({ theme }) => theme.spacing(3)};
    margin: ${({ theme }) => theme.spacing(4)} auto;
    border-radius: 8px;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;


export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.xxl};
  font-weight: 700;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.colors.white};
  letter-spacing: 0.05em;

  @media (min-width: ${({ theme }) => theme.phoneWidth}) {
    font-size: ${({ theme }) => theme.fontSizes.xxl};
  }
`;

export const Btn = styled.button`
  display: inline-block;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  background: ${props => {
    switch (props.type) {
      case 'primary':
        return props.theme.colors.primary;
      case 'secondary':
        return props.theme.colors.secondary;
      default:
        return props.theme.colors.primary;
    };
  }};

  color: ${props => {
    switch (props.type) {
      case 'primary':
        return props.theme.colors.white;
      case 'secondary':
        return props.theme.colors.primary;
      default:
        return props.theme.colors.white;
    };
  }};

  border: ${props => {
    switch (props.type) {
      case 'primary':
        return 'none';
      case 'secondary':
        return `1px solid ${props.theme.colors.primary}`;
      default:
        return 'none';
    };
  }};

  ${props => props.size === 'small' && `
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
  `}

  ${props => props.size === 'medium' && `
    padding: 10px 16px;
    font-size: 16px;
    font-weight: 500;
  `}

  ${props => props.size === 'large' && `
    padding: 14px 20px;
    font-size: 18px;
    font-weight: 600;
  `}

  &:hover {
    background: ${props => {
    switch (props.type) {
      case 'primary':
        return props.theme.colors.highlightPrimary;
      default:
        return props.theme.colors.highlightPrimary;;
    };
  }};
    color: ${props => {
    switch (props.type) {
      case 'secondary':
        return props.theme.colors.white;
      default:
        return props.theme.colors.white;
    };
  }};
    transform: ${props => {
    return 'translateY(-2px)';
  }};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: ${({ theme }) => theme.phoneWidth}) {
    max-width: 300px;
    margin-bottom: 10px;
  }

  @media (max-width: ${({ theme }) => theme.tabletWidth}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ButtonGroup = styled.div`
  display: inline-flex;
  gap: 1rem;
  margin: 1rem 0;

  @media (max-width: ${({ theme }) => theme.phoneWidth}) {
    max-width: 300px;
  }
`;
